export enum LoginSwalButtons {
  Proceed = 'proceed',
  Import = 'import',
}
